/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/compass-active': {
    width: 69,
    height: 69,
    viewBox: '0 0 69 69',
    data: '<circle cx="34.13" cy="34.13" r="32.63" fill="white" stroke="black" stroke-width="3"/><path d="M34 6L41 33.7692H27L34 6Z" fill="black"/><path d="M34 61.5386L27 33.7692H41L34 61.5386Z" fill="black"/><circle cx="34" cy="34" r="3" fill="white"/>'
  }
})
